import React, { useCallback } from 'react';
import { Dialog, DialogContent } from '@/components/ui/dialog';
import { Link, useHistory } from 'react-router-dom';
import { IoWarningOutline } from 'react-icons/io5';
import { IoMdPersonAdd } from 'react-icons/io';
import { TiPencil } from 'react-icons/ti';
import { useAuth } from '../../../hooks/AuthContext';

const ModalNoCompany: React.FC = () => {
  const { push } = useHistory();
  const { setModalNoCompanyStatus, modalNoCompanyStatus } = useAuth();

  const handleClose = useCallback(() => {
    setModalNoCompanyStatus(false);
    push('/');
  }, [push, setModalNoCompanyStatus]);

  return (
    <Dialog open={modalNoCompanyStatus} onOpenChange={handleClose}>
      <DialogContent className="sm:max-w-[500px]">
        <div className="flex flex-col items-center px-5 pb-4">
          <IoWarningOutline size={80} className="mb-[3%] text-yellow-500" />
          <span className="text-center text-2xl font-medium leading-7">
            Percebemos que você não está vinculado à nenhuma companhia. Para uso
            dos nossos serviços, isto é necessário.
          </span>
          <Link
            to="/"
            onClick={() => setModalNoCompanyStatus(false)}
            className="mt-8 flex items-center text-lg text-primary no-underline hover:opacity-80"
          >
            <IoMdPersonAdd className="mr-1 h-5 w-5" /> Aguardar um convite
          </Link>
          <Link
            to="/companies"
            onClick={() => setModalNoCompanyStatus(false)}
            className="mt-8 flex items-start text-lg text-primary no-underline hover:opacity-80"
          >
            <TiPencil className="mr-1 h-5 w-5" /> Cadastrar uma companhia agora
          </Link>
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default ModalNoCompany;
